import { useCallback, useState } from 'react';

const useModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const onCloseModal = useCallback(() => setIsModalOpen(false), []);
    const openModal = useCallback(() => setIsModalOpen(true), []);
    const onToggleModal = useCallback(() => setIsModalOpen(!isModalOpen), [isModalOpen]);

    return {
        isModalOpen,
        setIsModalOpen,
        onCloseModal,
        onToggleModal,
        openModal,
    };
};

export default useModal;
